import { demoLinkProps } from '../utils/calendly.js';
import useDocumentMeta from '../hooks/useDocumentMeta.js';

const STYLES = `
.notfound {
  position: relative;
  min-height: calc(100vh - 120px);
  padding: var(--space-80) var(--gutter);
  display: grid;
  place-items: center;
  overflow: hidden;
}

.notfound__inner {
  position: relative;
  z-index: 1;
  max-width: 720px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-24);
}

.notfound__code {
  font-family: var(--font-display, 'Sora', sans-serif);
  font-size: clamp(6rem, 16vw, 13rem);
  font-weight: var(--fw-bold, 700);
  line-height: 0.9;
  letter-spacing: var(--ls-tight, -0.04em);
  color: var(--color-text, #171717);
  margin: 0;
}

.notfound__title {
  font-size: var(--fs-h4);
  line-height: var(--lh-tight);
  letter-spacing: var(--ls-tight);
  color: var(--color-text, #171717);
  margin: 0;
}

.notfound__sub {
  font-size: var(--fs-body-xl);
  color: var(--color-text-muted, rgba(23, 23, 23, 0.62));
  max-width: 520px;
  margin: 0 auto;
}

.notfound__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--space-16);
  margin-top: var(--space-12);
}

.notfound__links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--space-24);
  margin-top: var(--space-32);
  padding-top: var(--space-24);
  border-top: 1px solid rgba(23, 23, 23, 0.08);
  width: 100%;
  max-width: 520px;
}

.notfound__link {
  display: inline-flex;
  align-items: center;
  gap: var(--space-8);
  font-size: var(--fs-body-md);
  font-weight: var(--fw-medium, 500);
  color: var(--color-text-muted, rgba(23, 23, 23, 0.62));
  text-decoration: none;
  transition: color var(--t-base, 200ms);
}

.notfound__link:hover {
  color: var(--color-text, #171717);
}

.notfound__link i {
  font-size: 14px;
}

@media (max-width: 720px) {
  .notfound__title { font-size: var(--fs-h5); }
  .notfound__sub { font-size: var(--fs-body-md); }
  .notfound__actions { flex-direction: column; width: 100%; }
  .notfound__actions .btn { width: 100%; justify-content: center; }
}
`;

export default function NotFound() {

  useDocumentMeta({
    title: '404 — Page Not Found',
    description: "The page you're looking for doesn't exist. Head back to the homepage to keep exploring Account Editor.",
    noindex: true
  });

  return (
    <>
      <style>{STYLES}</style>
      <section className="notfound">
        <div className="container notfound__inner">
          <span className="eyebrow">
            Page not found
          </span>

          <div className="notfound__code" aria-hidden="true">404</div>

          <h1 className="notfound__title">
            This page took an early <span>cancel.</span>
          </h1>

          <p className="notfound__sub">
            The link you followed may be broken, or the page may have been moved. Let's get you
            back to something useful.
          </p>

          <div className="notfound__actions">
            <a href="/" className="btn btn--primary btn--lg">
              <i className="ph ph-house" aria-hidden="true"></i>
              Back to home
            </a>
            <a
              {...demoLinkProps('notfound-demo')}
              className="btn btn--secondary btn--lg"
            >
              <i className="ph ph-calendar-dots" aria-hidden="true"></i>
              Book a demo
            </a>
          </div>

          <div className="notfound__links">
            <a href="/features" className="notfound__link">
              <i className="ph ph-arrow-right" aria-hidden="true"></i>
              Features
            </a>
            <a href="/pricing" className="notfound__link">
              <i className="ph ph-arrow-right" aria-hidden="true"></i>
              Pricing
            </a>
            <a href="/case-studies" className="notfound__link">
              <i className="ph ph-arrow-right" aria-hidden="true"></i>
              Case Studies
            </a>
            <a href="/faqs" className="notfound__link">
              <i className="ph ph-arrow-right" aria-hidden="true"></i>
              FAQ
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
